import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@bingads-webui-react/alert';
import { mapAlertLevel } from './util';

const methodPrefix = 'floatingBanner';
const logType = {
  message: 'message',
  action: 'action',
  dismiss: 'dismiss',
};

export class FloatingBanner extends React.Component {
  constructor(props) {
    super(props);
    const nextMessage = this.props.alert && this.props.alert.message;
    this.state = { showBanner: _.isString(nextMessage) || React.isValidElement(nextMessage) };
  }

  componentDidMount() {
    this.afterUpdate();
  }

  componentDidUpdate() {
    this.afterUpdate();
  }

  componentWillUnmount() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  }

  logTrace = (type, appendantInfo) => {
    const methodName = `${methodPrefix}:${type}`;
    const message = _.reduce(
      appendantInfo,
      (memo, info) => `${memo}:${info}`,
      `${this.props.alert.level}:${(_.isString(this.props.alert.message) ? this.props.alert.message : 'ReactElement')}`
    );

    this.props.logInstrumentation.trace(methodName, message);
  }

  afterUpdate = () => {
    if (this.state.showBanner) {
      this.logTrace(logType.message);
      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      if (this.props.autoDismissTime > 0) {
        this.timerId = setTimeout(() => {
          this.dismiss(false);
        }, this.props.autoDismissTime);
      }
    }
  }

  dismiss = (willLog = true) => {
    if (willLog) {
      this.logTrace(logType.dismiss);
    }

    this.setState({ showBanner: false });
  }

  actionClicked = (innerText) => {
    this.logTrace(logType.action, [innerText]);
  }

  render() {
    return (
      <div>
        { this.state.showBanner && (
          <div className="floating-banner">
            <Alert
              {...mapAlertLevel(this.props.alert)}
              onDismiss={this.dismiss}
              onActionClicked={this.actionClicked}
            />
          </div>
        ) }
      </div>
    );
  }
}

FloatingBanner.propTypes = {
  alert: PropTypes.shape({
    message: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]),
    level: PropTypes.string,
  }),
  autoDismissTime: PropTypes.number,
  logInstrumentation: PropTypes.shape({
    trace: PropTypes.func,
  }),
};

FloatingBanner.defaultProps = {
  alert: {
    message: undefined,
    level: 'Confirmation',
  },
  autoDismissTime: 0,
  logInstrumentation: {
    trace: _.noop,
  },
};
